import React from 'react';
import { CheckIcon, FileTextIcon, LockIcon, MailIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { useCountdown } from '../contexts/CountdownContext';
import { offer, offerItems, paymentMethods } from '../data/offer';
export function OfferCard() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'ore'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const perks = [{
    icon: ZapIcon,
    label: 'Accesso immediato'
  }, {
    icon: FileTextIcon,
    label: 'Solo PDF'
  }, {
    icon: MailIcon,
    label: 'Via email'
  }];
  return <section id="offerta" className="bg-ivory-2 px-5 py-14" data-id="element-184" data-mp="15gg703y6syc2">
      <SectionHeading eyebrow="L’offerta" title="Ottieni il pack" accent="completo oggi" sub="Un solo pagamento. Accesso a vita. Nessun abbonamento." data-id="element-185" data-mp="22wlq4epnx86d" />
      <Reveal className="mt-9" data-id="element-186" data-mp="8fb19bdvshdi">
        <div className="overflow-hidden rounded-3xl border-2 border-wood bg-ivory-white shadow-frame" data-id="element-187" data-mp="8h48arsep3m1">
          <div className="bg-espresso px-5 py-3.5 text-center" data-id="element-188" data-mp="dee6owxrwpm0">
            <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-wood" data-id="element-189" data-mp="3vtf1q2aks1rr">Tutto quello che ricevi</p>
          </div>
          <div className="p-5" data-id="element-190" data-mp="3nrvrg104n9n">
            <ul className="space-y-3" data-id="element-191" data-mp="3mq9sgig6gd5">
              {offerItems.map(item => <li key={item.label} className="flex items-baseline gap-2.5" data-id="element-192" data-mp="3ltee445oazhr">
                  <CheckIcon className="h-4 w-4 shrink-0 translate-y-0.5 text-leaf" strokeWidth={3} aria-hidden="true" data-id="element-193" data-mp="3qulkpzw2xsmu" />
                  <span className="text-[14px] text-ink" data-id="element-194" data-mp="3cvudmxfmx787">{item.label}</span>
                  <span className="ml-auto shrink-0 text-[14px] font-semibold text-ink-muted" data-id="element-195" data-mp="3gwe8tvgne0rp">{item.value}</span>
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ivory-line pt-7 text-center" data-id="element-196" data-mp="1f4rp8ez35859">
              <p className="text-base text-ink-muted" data-id="element-197" data-mp="2o16ly76nl5co">
                Valore totale: <span className="line-through" data-id="element-198" data-mp="2o2hsgerhgr7h">{offer.totalValue}</span>
              </p>
              <span className="mt-4 inline-flex rounded-full bg-alert px-4 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-white" data-id="element-199" data-mp="2j0k1eycucs3z">
                Solo oggi
              </span>
              <p className="mt-3 font-display text-[88px] leading-none text-ink" data-id="element-200" data-mp="2a2qf8g8sjeuj">{offer.price}</p>
              <p className="mt-1 font-serif text-base italic text-ink-muted" data-id="element-201" data-mp="36qed3clfcamn">
                {offer.currency} · Pagamento unico
              </p>

              <ul className="mt-5 grid grid-cols-3 gap-2" data-id="element-202" data-mp="2xze06i9k59az">
                {perks.map(({
                icon: Icon,
                label
              }) => <li key={label} className="flex flex-col items-center gap-1 rounded-xl bg-ivory-2 px-1 py-2.5" data-id="element-203" data-mp="2t0szyiub2pmj">
                    <Icon className="h-4 w-4 text-wood-dark" aria-hidden="true" data-id="element-204" data-mp="3qfx7mo0usayl" />
                    <span className="text-[11px] font-semibold text-ink" data-id="element-205" data-mp="3lof3jr3j9u9e">{label}</span>
                  </li>)}
              </ul>

              <CtaButton className="mt-6" data-id="element-206" data-mp="3t1o5qk7vdich">Ordina ora</CtaButton>

              <p className="mt-4 flex items-center justify-center gap-1.5 text-sm font-medium text-leaf-dark" data-id="element-207" data-mp="1t0i1xm5pj1r">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-208" data-mp="6rty9xstvo5m" />
                Pagamento 100% sicuro
              </p>
              <ul className="mt-3 flex flex-wrap justify-center gap-1.5" aria-label="Metodi di pagamento accettati" data-id="element-209" data-mp="avt9c0vc9url">
                {paymentMethods.map(m => <li key={m} className="rounded-md border border-ivory-line bg-white px-2 py-1 text-[10px] font-bold text-ink-body" data-id="element-210" data-mp="krw9502pxhbd">
                    {m}
                  </li>)}
              </ul>

              <div className="mt-7 rounded-2xl bg-espresso px-4 py-5" data-id="element-211" data-mp="uh63ynoy5e36">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sand" data-id="element-212" data-mp="ykks61n1h0rp">L’offerta scade tra</p>
                <div className="mt-3 flex items-center justify-center gap-2" role="timer" data-id="element-213" data-mp="13k76yfiimp2m">
                  {units.map((u, i) => <React.Fragment key={u.label} data-id="element-214" data-mp="puc8lfytnjhe" data-mpi={i}>
                      {i > 0 && <span className="font-display text-2xl text-wood" data-id="element-215" data-mp="ltse6k5mutyy">:</span>}
                      <span className="flex flex-col items-center" data-id="element-216" data-mp="zmrtal1i6m5z">
                        <span className="min-w-[3.25rem] rounded-lg bg-espresso-3 px-2 py-1.5 font-display text-3xl tabular-nums text-wood" data-id="element-217" data-mp="zo2wojr1drwk">
                          {u.value}
                        </span>
                        <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-sand" data-id="element-218" data-mp="2vzavgr3ki11">{u.label}</span>
                      </span>
                    </React.Fragment>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}